module.exports = __webpack_public_path__ + "img/apache.a67d54c.svg";